import React, { Fragment, useState, useEffect, useRef } from "react";
/* eslint import/no-webpack-loader-syntax: off */
import Arrow from "-!svg-react-loader!../../icons/arrow-down.svg";

import "./style.css";

const AskedQuestions = () => {
  const [isOpen, setIsOpen] = useState([]);

  const onClick = (index) => {
    setIsOpen((prevOpen) => {
      const newOpen = [...prevOpen];
      newOpen[index] = !newOpen[index];
      return newOpen;
    });
  };

  const textWrapperRefs = useRef([]);

  useEffect(() => {
    textWrapperRefs.current.forEach((ref, index) => {
      if (ref) {
        ref.style.height = isOpen[index] ? `${ref.scrollHeight}px` : "0";
      }
    });
  }, [isOpen]);

  const items = [
    {
      title: "What is your stretcher bar quality like?",
      text: "Like anything, there is a wide spectrum of quality when it comes to stretcher bars and its often difficult to fully appreciate the difference unless you get to look and feel various samples. We would welcome you at our showroom if you’d like to see some examples.",
      text2:
        "Our stretcher bars are imported from Italy and are made from pinewood using a finger joined technique. This approach ensures the stretcher bars are less prone to twisting and warping compared to a solid wood bar.",
      text3:
        "It is our belief that our stretcher bars are at the very high-end of options available in Singapore.",
    },
    {
      title: "Does your quote function include delivery and installation?",
      text: "No, our quote function provides you with a general idea of the cost of stretching the canvas only. For delivery fees it will depend on the size of the canvas, but it is likely to range from $20 - $60.",
      text2:
        "We don’t directly offer installation but we can help arrange professional installers for you and include it within the same invoice or you can pay them directly. We only use professionals who have plenty of experience in handling and installing art works.",
    },
    {
      title: "Can you stretch larger canvases than your quote function allows?",
      text: "Our online quote functionality is limited to 150 x 150cm [59 x 59 inches]. We can however do larger canvas stretching but it requires additional challenges with regards transportation so we ask that you kindly reach out for further discussion.",
    },
    {
      title: "How should I correctly measure my canvas?",
      text: "Most canvas works will have a printed/painted area and then raw canvas around the edges that is used to stretch around the wooden stretcher bars. When measuring and using our online quote function, please just measure the printed/painted area.",
      text2:
        "If your canvas has less than 3.8cm [1.5”] of raw canvas around the edges you may want to get in touch with us to discuss stretching options and pricing.",
    },
    {
      title: "Can you add a float frame to my stretched canvas?",
      text: "Yes we can. Please get in touch with us to get a quote and discuss your options.",
    },
    {
      title: "What is a stretcher bar?",
      text: "A stretcher bar is the wooden construction used to mount a canvas across. Stretcher bars come in various sizes but we stock 1” and 1.5” depth. Please note that for simplicity sake our online quote function is only based on 1” depth. If you would like a deeper stretcher bar, please get in touch.",
    },
  ];

  return (
    <Fragment>
      <h2 className="questions-section__title">Frequently asked questions</h2>
      <div className="questions-section--wrapper">
        {items.map((item, index) => (
          <div
            className={`questions-section__item ${
              isOpen[index] ? "questions-section__item--isOpen" : ""
            }`}
            key={index}
            onClick={() => onClick(index)}
          >
            <div className="questions-section__item__title">
              {item.title}{" "}
              <Arrow
                className={`questions-section__item__icon ${
                  isOpen[index] ? "questions-section__item__icon--open" : ""
                }`}
              />
            </div>
            <div
              className={`questions-section__item__text--wrap ${
                isOpen[index] ? "questions-section__item__text--wrap--open" : ""
              }`}
              ref={(el) => (textWrapperRefs.current[index] = el)}
            >
              <div className="questions-section__item__text">{item.text}</div>
              {item.text2 && (
                <div className="questions-section__item__text">
                  {item.text2}
                </div>
              )}
              {item.text3 && (
                <div className="questions-section__item__text">
                  {item.text3}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </Fragment>
  );
};

export default AskedQuestions;



// WEBPACK FOOTER //
// ./src/new-components/asked-questions/index.js